export default "__VITE_ASSET__9bf74f12__"